export enum MediaTypeEnum {
  // Logo
  LOGO = 'logo',
  // 图片
  IMAGE = 'image',
  // 音频
  AUDIO = 'audio',
  // 视频
  VIDEO = 'video',
  // 管理员头像
  ADMIN_AVATAR = 'admin-avatar',
  // 新闻封面
  NEWS_COVER = 'news-cover',
  // 项目封面
  PROJECT_COVER = 'project-cover',
}
